var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M-1-1h36v36H-1z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    stroke: "#453c90",
    cy: 17.227,
    cx: 16.75,
    strokeWidth: 1.5,
    fill: "#453c90",
    r: 16
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    strokeWidth: 1.5,
    fill: "none",
    d: "M11.375 17.328h11.75"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "null",
    strokeLinejoin: "null",
    strokeOpacity: "null",
    strokeWidth: 1.5,
    stroke: "#fff",
    fill: "none",
    d: "M17.063 11.557v11.75"
  }))));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzQiIGhlaWdodD0iMzQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiA8IS0tIENyZWF0ZWQgd2l0aCBNZXRob2QgRHJhdyAtIGh0dHA6Ly9naXRodWIuY29tL2R1b3BpeGVsL01ldGhvZC1EcmF3LyAtLT4KIDxnPgogIDx0aXRsZT5iYWNrZ3JvdW5kPC90aXRsZT4KICA8cmVjdCBmaWxsPSJub25lIiBpZD0iY2FudmFzX2JhY2tncm91bmQiIGhlaWdodD0iMzYiIHdpZHRoPSIzNiIgeT0iLTEiIHg9Ii0xIi8+CiA8L2c+CiA8Zz4KICA8dGl0bGU+TGF5ZXIgMTwvdGl0bGU+CiAgPGVsbGlwc2Ugc3Ryb2tlPSIjNDUzYzkwIiByeT0iMTUuOTk5ODIiIHJ4PSIxNS45OTk4MiIgaWQ9InN2Z18yIiBjeT0iMTcuMjI2NTYiIGN4PSIxNi43NSIgc3Ryb2tlLXdpZHRoPSIxLjUiIGZpbGw9IiM0NTNjOTAiLz4KICA8bGluZSBzdHJva2U9IiNmZmZmZmYiIHN0cm9rZS1saW5lY2FwPSJudWxsIiBzdHJva2UtbGluZWpvaW49Im51bGwiIGlkPSJzdmdfMyIgeTI9IjE3LjMyODEzIiB4Mj0iMjMuMTI1MDciIHkxPSIxNy4zMjgxMyIgeDE9IjExLjM3NDk3IiBzdHJva2Utd2lkdGg9IjEuNSIgZmlsbD0ibm9uZSIvPgogIDxsaW5lIHN0cm9rZS1saW5lY2FwPSJudWxsIiBzdHJva2UtbGluZWpvaW49Im51bGwiIGlkPSJzdmdfNCIgeTI9IjIzLjMwNjUzIiB4Mj0iMTcuMDYyNSIgeTE9IjExLjU1Njc0IiB4MT0iMTcuMDYyNSIgZmlsbC1vcGFjaXR5PSJudWxsIiBzdHJva2Utb3BhY2l0eT0ibnVsbCIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZT0iI2ZmZmZmZiIgZmlsbD0ibm9uZSIvPgogPC9nPgo8L3N2Zz4=";
export { SvgPlus as ReactComponent };